import BrandVideoPreview from '../'
import styled from 'styled-components'

export const ScrollCarousel = styled.div`
    -webkit-overflow-scrolling: touch;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    position: relative;
    text-align: left;
    /* make sure gifs are fully visible with a scrollbar */
    padding-bottom: 10px;
`

export const VideoPreview = styled(BrandVideoPreview)`
    position: relative;
    display: inline-block;
    list-style: none;
    margin-left: 6px;
    &:first-of-type {
        margin-left: 0;
    }
    img {
        position: absolute;
        top: 0;
        left: 0;
    }
`
